import { Plans } from "./Plans";
import { CheckIns } from "./CheckIns";
import ToolboxOverview from "./ToolboxOverview";
import ToolboxProfilePage from "./ToolboxProfilePage";
import ToolboxResponsesPage from "./ToolboxResponsesPage";

export const ToolboxPage = {
  Overview: ToolboxOverview,
  Profile: ToolboxProfilePage,
  Responses: ToolboxResponsesPage,
  Plans,
  CheckIns,
};
